import React, { Component } from "react";
import { Link } from "react-router-dom"
import { generalS } from "../../strings/general";
import madboya from "../../imgs/favicon.png";
import LanguageMenu from "./LanguageMenu";
import Drawer from "./Drawer";
import DesktopMenu from "./DesktopMenu";
import SearchManager from "./search/SearchManager"

import "../../styles/css/header.css";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      langMenu: false,
      langMenuLabl: "",
    };
  }

  updateLanguage = value => {
    this.props.context.setLanguage(value);
  };

  handlLandMenuClose = (event) => {
    this.setState({ langMenu: false, langMenuLabl: event.currentTarget })
  }

  languageHandler = (lang) => {
    // this.props.context.setLanguage(lang)
    if (this.props.changeLanguageHandler) {
      this.props.changeLanguageHandler(lang)
    }
  }

  render() {
    let { context, posts, language } = this.props;
    let { windowWidth, authenticated } = context;
    return (
      <div className={"g-sticky-header"}>
        <div className={"g-vertical-align-containers"}>
          {windowWidth <= 1024 ?
            <div className={"header-drawer"}>
              <Drawer language={language} context={context} authenticated={authenticated} />
            </div>
            : (
              <div className={"header-logo"}>
                <Link to="/">
                  <img
                    src={madboya}
                    style={{ width: 92 }}
                  />
                </Link>
              </div>
            )}
          {windowWidth <= 1024 ?
            <div className={"header-logo"}>
              <Link to="/">
                <img
                  src={madboya}
                  style={{ width: 92 }}
                />
              </Link>
            </div>
            : (
              <div className={"header-drawer"}>
                <DesktopMenu language={language} authenticated={authenticated} context={context} />
              </div>
            )}
          <div className={"header-lang-search-container"}>
            <LanguageMenu
              context={context}
              languageHandler={(language) => {
                this.languageHandler(language)
              }}
              language={language}
            />
            <SearchManager language={language} posts={posts} />
          </div>
        </div>
      </div>
    );
  }
}


export default Header;
